import { storeManager } from '@pressreader/appstore';

import { STORE_SECTION_NAME } from './constants';
import { reducer } from './reducers';

storeManager.addFeature(STORE_SECTION_NAME, reducer);

export * from './actions';
export * from './sagas/utils';
export * from './selectors';
